import { render, staticRenderFns } from "./CommunicationItemCall.vue?vue&type=template&id=4cedcf0c&"
import script from "./CommunicationItemCall.vue?vue&type=script&lang=js&"
export * from "./CommunicationItemCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports